import React from 'react'
import * as S from './style'
import Button from 'presentation/shared/components/Button'
import Modal from 'presentation/shared/components/Modal'
import { ReactComponent as DownloadIcon } from 'presentation/assets/icons/DonwloadIcon.svg'
import { ReactComponent as CloseIcon } from 'presentation/assets/icons/close.svg'
import SelectField from 'presentation/shared/components/SelectField'
import { useServices } from 'presentation/hooks/use-services'
import {
  HealthInsuranceEnum,
  statusEligibilityDocumentsEnum
} from 'presentation/hospital/layouts/SurgicalOrder/types'
import { toast } from 'react-toastify'
import moment from 'moment'
import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import ButtonNew from 'presentation/shared/components/ButtonNew'

type EligibilityDocumentationProps = {
  health_insurance_status_id: number
  file_name: string
  documentations: any
  eligibilityStatus: string
  findConsultsEligibility: () => void
}

const EligibilityDocument = WithLoading(
  ({
    health_insurance_status_id,
    file_name,
    documentations,
    eligibilityStatus,
    findConsultsEligibility,
    setIsLoading
  }: EligibilityDocumentationProps & WithLoadingProps) => {
    const elegibilityService = useServices().eligibility
    const [showModal, setShowModal] = React.useState(false)
    const [statusEligibilityDocument, setStatusEligibilityDocument] =
      React.useState<statusEligibilityDocumentsEnum>(
        statusEligibilityDocumentsEnum.APPROVED
      )

    const handleSubmit = async () => {
      try {
        setIsLoading(true)
        await elegibilityService.updateEligibilityDocument({
          health_insurance_status_id,
          document_status: statusEligibilityDocument
        })
        toast.success('Documento atualizado.')
        setShowModal(false)
        findConsultsEligibility()
      } catch (error) {
        toast.error('Erro na atualização do documento. Tente novamente.')
      } finally {
        setIsLoading(false)
      }
    }

    const statusEligibility = [
      { label: 'Validado', value: statusEligibilityDocumentsEnum.APPROVED },
      { label: 'Invalidado', value: statusEligibilityDocumentsEnum.DISAPPROVED }
    ]

    if (eligibilityStatus === HealthInsuranceEnum.INELIGIBLE) {
      return <span>Sem anexos</span>
    } else if (eligibilityStatus === HealthInsuranceEnum.ELIGIBLE_PENDING) {
      return (
        <>
          <S.LinkContainer>
            <a href={file_name} target="_blank" rel="noreferrer">
              <DownloadIcon width={25} height={25} />
              Eligibilidade.pdf
            </a>
          </S.LinkContainer>
        </>
      )
    } else
      return (
        <>
          <S.LinkContainer>
            <a href={file_name} target="_blank" rel="noreferrer">
              <DownloadIcon width={25} height={25} />
              Eligibilidade.pdf
            </a>
          </S.LinkContainer>

          {eligibilityStatus === HealthInsuranceEnum.ELIGIBLE &&
            !!file_name &&
            !documentations && (
              <S.Buttons>
                <ButtonNew
                  size={'medium'}
                  outlined
                  type="button"
                  onClick={() => setShowModal(true)}
                >
                  Validar
                </ButtonNew>
              </S.Buttons>
            )}

          <S.StatusContainer>
            <span>
              {documentations?.document_status ===
                statusEligibilityDocumentsEnum.APPROVED && (
                <S.ValidedStatus>Validado</S.ValidedStatus>
              )}

              {documentations?.document_status ===
                statusEligibilityDocumentsEnum.DISAPPROVED && (
                <S.InvalidedStatus>Invalidado</S.InvalidedStatus>
              )}

              {documentations?.document_status ===
                statusEligibilityDocumentsEnum.ANALYZING && (
                <S.ValidedStatus>Validação Pendente</S.ValidedStatus>
              )}
            </span>
            <S.CustomDescription>
              {' em '}

              {moment.utc(documentations?.updated_at).format('DD/MM/YYYY')}

              {' por '}
              {documentations?.user.name}
            </S.CustomDescription>
          </S.StatusContainer>

          <Modal
            show={showModal}
            bgZIndex={1}
            style={{ width: '100%', maxWidth: '500px', padding: 0 }}
          >
            <S.Wrapper>
              <S.Header>
                <h4>Validação de documento de eligibilidade</h4>
                <CloseIcon onClick={() => setShowModal(false)} />
              </S.Header>
              <S.line />
              <S.Body>
                <p>Confira o documento de elegibilidade e valide-o.</p>
              </S.Body>
              <S.Form role="form">
                <S.CustomLabel>
                  Validar documento de elegibilidade
                </S.CustomLabel>
                <SelectField
                  name="eligibilityDocumentStatus"
                  items={statusEligibility}
                  value={statusEligibilityDocument}
                  outline={true}
                  onInputChange={(value) => {
                    const val =
                      value === 'approved'
                        ? statusEligibilityDocumentsEnum.APPROVED
                        : statusEligibilityDocumentsEnum.DISAPPROVED

                    setStatusEligibilityDocument(val)
                  }}
                  required
                  labelColor={'neutralBlack'}
                />
                <S.FormButtons>
                  <Button
                    type="button"
                    variant="text"
                    fullWidth={false}
                    onClick={() => setShowModal(false)}
                  >
                    Cancelar
                  </Button>
                  <Button fullWidth={false} onClick={handleSubmit}>
                    Confirmar
                  </Button>
                </S.FormButtons>
              </S.Form>
            </S.Wrapper>
          </Modal>
        </>
      )
  }
)

export default EligibilityDocument
